/**
 * @description 文件上传限制
 */
import { Message } from "element-ui";

/**
 * 校验字母,数字,字母+数字 ,字符范围：1-50
 * @param {*} file 返回的结果
 * @param {*} type 允许的上传类型
 * @param {*} size 上传的文件大小单位mb
 * @param {*} obj  obj里面有limit字段说明上传的权限 data是当前已经上传的数组
 * @returns
 */
export function beforeAvatarUpload(file, type = [], size, obj = false) {
	if (obj) {
		if (obj.data.length >= obj.limit && (obj.limit || 0) > 0) {
			Message.error(`最多上传${obj.limit}张`);

			return false;
		}
	}

	let is_ok = type.indexOf(file.type) == -1 ? false : true;
	let isLt2M = null;

	if (!is_ok) {
		Message.error(`请上传${type.toString()}的格式`);
	}

	if (size) {
		isLt2M = file.size / 1024 / 1024 < size;

		if (!isLt2M) {
			is_ok = false;
			Message.error(`上传图片大小不能超过 ${size}MB!`);
		}
	}

	return is_ok;
}
